<common-confirm></common-confirm>

<mat-card>
    <h1 class="color-accent">Shuffle packages</h1>
    <div>
        <div class="margin-bottom-20" *ngIf="packages.length && shipment">
            <h3>Select package:</h3>

            <mat-button-toggle-group [formControl]="packageSelected">
                <mat-button-toggle [value]="null">All</mat-button-toggle>
                <mat-button-toggle *ngFor="let pack of packages | filter:'shipment_id':'==':shipment.id"
                                   [value]="pack.name">
                    {{ pack.name }}
                    <span class="text-error">{{ pack.warehouse_transactions_count < 1 ? " (Empty)" : "" }}</span>
                </mat-button-toggle>

            </mat-button-toggle-group>
        </div>
        <div class="clear"></div>
    </div>


    <div class="clear margin-bottom-20"></div>

    <mat-tab-group *ngIf="shipment" [selectedIndex]="selected_tab">
        <mat-tab label="Items">
            <ng-template matTabContent>
                <section-warehouse-order-wizard-shuffle-items #itemsList
                                                              [state]="state"
                                                              [shipment]="shipment"
                                                              [packages]="packages"
                                                              [selected_package_name]="packageSelected.value"
                                                              (onUpdate)="getPackages()">
                </section-warehouse-order-wizard-shuffle-items>
            </ng-template>
        </mat-tab>

        <mat-tab label="Boxes">
            <ng-template matTabContent>
                <section-warehouse-order-wizard-shuffle-boxes #boxList
                                                              [state]="state"
                                                              [shipment_id]="shipment.id"
                                                              [packages]="packages"
                                                              [selected_package_name]="packageSelected.value"
                                                              (onUpdate)="getPackages()">
                </section-warehouse-order-wizard-shuffle-boxes>
            </ng-template>
        </mat-tab>

        <mat-tab label="Pallets">
            <ng-template matTabContent>
                <section-warehouse-order-wizard-shuffle-pallets #palletList
                                                                [state]="state"
                                                                [shipment_id]="shipment.id"
                                                                [packages]="packages"
                                                                [selected_package_name]="packageSelected.value"
                                                                (onUpdate)="getPackages()">
                </section-warehouse-order-wizard-shuffle-pallets>
            </ng-template>
        </mat-tab>
    </mat-tab-group>
</mat-card>
